import { Button } from "@/components/ui/button"
import { useTrialForm } from "./useTrialForm"
import { CustomCountrySelect } from './CustomCountrySelect'
import { Link } from 'react-router-dom'
import { toast } from 'sonner'
export function TrialFormPage() {
  const { formData, errors, isSubmitting, updateField, handleSubmit, resetForm } = useTrialForm()

  const onSubmit = (e) => {
    e.preventDefault()
    handleSubmit(() => {
      resetForm()
      toast.success('Check your email for further information');
    })
  }

  return (
    <div className="pb-[120px] bg-black text-white">
      <div className="h-[160px] text-[38px] bg-cover
      bg-[url('@/assets/images/contact-us.jpg')] bg-no-repeat bg-center mb-[32px]">
        <div className="h-full container-max-w mx-auto flex items-center">Tell us About yourself  </div>
      </div>
      <div className="container-max-w mx-auto">
        <form onSubmit={onSubmit} className="grid grid-cols-1 md:grid-cols-2 gap-8">
          <div className="space-y-6">
            <div className="space-y-2">
              <label className="font-medium text-white text-[16px]">First name</label>
              <input
                type="text"
                value={formData.firstName}
                onChange={(e) => updateField("firstName", e.target.value)}
                className="w-full px-3 py-2 bg-white text-black border"
              />
              {errors.firstName && <p className="text-sm text-[#ED2D00]">{errors.firstName}</p>}
            </div>

            <div className="space-y-2">
              <label className="font-medium text-white text-[16px]">Last name</label>
              <input
                type="text"
                value={formData.lastName}
                onChange={(e) => updateField("lastName", e.target.value)}
                className="w-full px-3 py-2 bg-white text-black border"
              />
              {errors.lastName && <p className="text-sm text-[#ED2D00]">{errors.lastName}</p>}
            </div>

            <div className="space-y-2">
              <label className="font-medium text-white text-[16px]">Business email</label>
              <input
                value={formData.email}
                onChange={(e) => updateField("email", e.target.value)}
                className="w-full px-3 py-2 bg-white text-black border"
              />
              {errors.email && <p className="text-sm text-[#ED2D00]">{errors.email}</p>}
            </div>

            <div className="space-y-2">
              <label className="font-medium text-white text-[16px]">Company</label>
              <input
                type="text"
                value={formData.company}
                onChange={(e) => updateField("company", e.target.value)}
                className="w-full px-3 py-2 bg-white text-black border"
              />
              {errors.email && <p className="text-sm text-[#ED2D00]">{errors.company}</p>}
            </div>
            <div className="space-y-2">
              <label className="font-medium text-white text-[16px]">Password</label>
              <input
                type="password"
                value={formData.password}
                onChange={(e) => updateField("password", e.target.value)}
                className="w-full px-3 py-2 bg-white text-black border"
                // placeholder="At least 8 characters"
              />
              {errors.password && <p className="text-sm text-[#ED2D00]">{errors.password}</p>}
            </div>
          </div>

          <div className="space-y-6">
            <div className="space-y-2">
              <label className="font-medium text-white text-[16px]">Confirm Password</label>
              <input
                type="password"
                value={formData.confirmPassword}
                onChange={(e) => updateField("confirmPassword", e.target.value)}
                className="w-full px-3 py-2 bg-white text-black border"
                // placeholder="Re-enter your password"
              />
              {errors.confirmPassword && <p className="text-sm text-[#ED2D00]">{errors.confirmPassword}</p>}
            </div>
            <div className="space-y-2">
              <label className="font-medium text-white text-[16px]">Country or region</label>
              <div className="relative">
                <CustomCountrySelect
                  className="h-[42px] rounded-none"
                  value={formData.country}
                  onChange={(value) => updateField("country", value)}
                  error={errors.country}
                />
              </div>
              {errors.country && <p className="text-sm text-[#ED2D00]">Country is Required</p>}
            </div>

            <div className="space-y-6">
              <div className="text-[16px] text-gray-300 leading-relaxed">
                By submitting this information, I agree to the{" "}
                <a href="#" className="text-[#4790FD] hover:underline hover:text-[#0066FF] font-bold">
                  privacy policy
                </a>{" "}
                and to learn more about products and services from iData.
                <br />
                This site is protected by reCAPTCHA and the{" "}
                <a href="#" className="text-[#4790FD] hover:underline hover:text-[#0066FF] font-bold">
                  Google Privacy Policy
                </a>{" "}
                and{" "}
                <Link to="/term-of-use" className="text-[#4790FD] hover:underline hover:text-[#0066FF] font-bold">
                  Terms of Use
                </Link>{" "}
                apply.
              </div>

              <Button
                type="submit"
                className="w-full bg-blue-600 hover:bg-[#297FFF] text-white py-3 h-[52px] text-[24px]"
                disabled={isSubmitting}
              >
                {isSubmitting ? "Submitting..." : "Submit"}
              </Button>
            </div>
          </div>
        </form>
      </div>
    </div>
  )
}
